<template>
    <div>
        <!-- Resumo curto (ex.: formulário de OS): sem grade nem blocos de rastreador/chip -->
        <div v-if="embeddedMinimal" class="header-admin-minimal">
            <template v-if="veiculo">
                <div class="header-admin-minimal__client">{{ veiculo.cliente ? veiculo.cliente.nome : 'Sem cliente' }}</div>
                <div class="header-admin-minimal__row text-uppercase">
                    <span class="header-admin-minimal__placa">{{ veiculo.placa }}</span>
                    <span class="header-admin-minimal__dot">·</span>
                    <span class="header-admin-minimal__veic">{{ veiculo.marca }} {{ veiculo.modelo }}<template v-if="veiculo.ano"> · {{ veiculo.ano }}</template></span>
                </div>
                <div
                    class="header-admin-minimal__flags"
                    v-if="veiculo.oficina || veiculo.sinistro"
                >
                    <span v-if="veiculo.oficina" class="label label-danger">Em oficina</span>
                    <span v-if="veiculo.sinistro" class="label label-warning">Em manutenção</span>
                </div>
            </template>
            <div
                class="alert alert-danger header-admin-minimal__alert"
                v-if="veiculo && veiculo.roubado"
            >VEÍCULO ROUBADO</div>
        </div>

        <div v-else-if="embedded" class="header-admin-embedded">
            <div class="header-admin-embedded__main">
                <div v-if="rastreador || posicao" class="header-admin-embedded__icons">
                    <div v-if="rastreador" class="header-admin-embedded__icon-wrap">
                        <icon-satelite-transmissao :data="rastreador.ultima_data_evento" />
                    </div>
                    <div v-if="posicao && veiculo" class="header-admin-embedded__icon-wrap">
                        <icon-color font-size="50px" :color-ign-off="posicao.color_icon" :ign="posicao.ignition" :icon="veiculo.tipo"></icon-color>
                    </div>
                    <div v-else-if="posicao" class="header-admin-embedded__icon-wrap">
                        <icon-color font-size="50px" :color-ign-off="posicao.color_icon" :ign="posicao.ignition" icon="car"></icon-color>
                    </div>
                </div>

                <div class="header-admin-embedded__body">
                    <template v-if="veiculo">
                        <div class="header-admin-embedded__head">
                            <div class="header-admin-embedded__client">
                                <vk-icon ratio="0.85" icon="user"></vk-icon>
                                {{ veiculo.cliente ? veiculo.cliente.nome : 'Sem Cliente' }}
                            </div>
                            <div class="header-admin-embedded__sub">
                                <vk-icon ratio="0.85" icon="location"></vk-icon>
                                Placa
                                <span class="header-admin-embedded__placa">{{ veiculo.placa }}</span>
                                <span class="header-admin-embedded__sep">·</span>
                                <span class="header-admin-embedded__mini text-uppercase">{{ veiculo.marca }} {{ veiculo.modelo }}<template v-if="veiculo.ano"> · {{ veiculo.ano }}</template></span>
                            </div>
                            <div class="header-admin-embedded__tags" v-if="veiculo.oficina || veiculo.sinistro || (posicao && posicao.ancorado)">
                                <span v-if="veiculo.oficina" class="label label-danger">EM OFICINA</span>
                                <span v-if="veiculo.sinistro" class="label label-warning">EM MANUTENÇÃO</span>
                                <span v-if="posicao && posicao.ancorado" class="label label-info">
                                    <vk-icon ratio="0.75" icon="bolt"></vk-icon>
                                    Ancorado
                                    <a
                                        v-if="veiculo.ancora"
                                        target="_blank"
                                        class="header-admin-embedded__ancora-link"
                                        :href="'https://www.google.com.br/maps/place/'+ veiculo.ancora.latitude +','+ veiculo.ancora.longitude +'/@'+ veiculo.ancora.latitude +','+ veiculo.ancora.longitude +',18z'"
                                    >Ver no mapa</a>
                                </span>
                            </div>
                        </div>

                        <div class="row header-admin-embedded__grid">
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="header-admin-field">
                                    <span class="header-admin-field__label">Marca</span>
                                    <span class="header-admin-field__value text-uppercase">{{ veiculo.marca || '—' }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="header-admin-field">
                                    <span class="header-admin-field__label">Modelo</span>
                                    <span class="header-admin-field__value text-uppercase">{{ veiculo.modelo || '—' }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="header-admin-field">
                                    <span class="header-admin-field__label">Ano</span>
                                    <span class="header-admin-field__value text-uppercase">{{ veiculo.ano || '—' }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="header-admin-field">
                                    <span class="header-admin-field__label">Chassi</span>
                                    <span class="header-admin-field__value text-uppercase">{{ veiculo.chassi || '—' }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="header-admin-field">
                                    <span class="header-admin-field__label">Renavam</span>
                                    <span class="header-admin-field__value text-uppercase">{{ veiculo.renavan || '—' }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <div class="header-admin-field">
                                    <span class="header-admin-field__label">Cor</span>
                                    <span class="header-admin-field__value text-uppercase">{{ veiculo.cor || '—' }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div v-if="rastreador" class="header-admin-embedded__block">
                        <div class="header-admin-embedded__block-title">Rastreador</div>
                        <div class="header-admin-embedded__block-line">
                            <vk-icon ratio="0.8" icon="tag"></vk-icon>
                            <span class="text-uppercase">{{ rastreador.cod_fab_rastreadores }} / {{ rastreador.modelo.nome }}</span>
                        </div>
                        <div class="header-admin-embedded__block-line">
                            <vk-icon ratio="0.8" icon="tag"></vk-icon>
                            Serial <strong class="text-uppercase">{{ rastreador.serial }}</strong>
                            <span class="header-admin-embedded__inline-sep"></span>
                            <vk-icon ratio="0.8" icon="clock"></vk-icon>
                            Último dado <strong>{{ rastreador.ultima_data_evento | date("DD-MM-YYYY HH:mm:ss") }}</strong>
                            <span class="header-admin-embedded__inline-sep"></span>
                            <vk-icon ratio="0.8" icon="rss"></vk-icon>
                            Porta <strong>{{ rastreador.porta }}</strong>
                        </div>
                    </div>

                    <div v-if="chip" class="header-admin-embedded__block">
                        <div class="header-admin-embedded__block-title">Chip / linha</div>
                        <div class="header-admin-embedded__block-line">
                            <vk-icon ratio="0.8" icon="tag"></vk-icon>
                            ICCID <strong class="text-uppercase">{{ chip.imei }}</strong>
                            <span class="header-admin-embedded__inline-sep"></span>
                            <vk-icon ratio="0.8" icon="receiver"></vk-icon>
                            <strong>{{ chip.numero }}</strong>
                            <span class="header-admin-embedded__inline-sep"></span>
                            <strong>{{ String(chip.operadora).toUpperCase() }}</strong>
                        </div>
                    </div>

                    <div class="alert alert-danger header-admin-embedded__alert" v-if="veiculo && veiculo.roubado">VEÍCULO ROUBADO</div>
                </div>
            </div>
        </div>

        <div v-else class="page-header" style="margin: 0 !important; margin-bottom: -30px; margin-top: -10px">
            <div class="row">
                <table style="width: 100%">
                    <tr>

                        <td v-if="rastreador" style="width: 65px; vertical-align: top; padding-top: 8px; padding-left: 10px">
                            <icon-satelite-transmissao :data="rastreador.ultima_data_evento" />
                        </td>

                        <td style="width: 60px; vertical-align: top; padding-top: 8px; padding-left: 10px" v-if="posicao && veiculo">
                            <icon-color font-size="50px" :color-ign-off="posicao.color_icon" :ign="posicao.ignition" :icon="veiculo.tipo"></icon-color>
                        </td>

                        <td style="width: 60px; vertical-align: top; padding-top: 8px; padding-left: 10px" v-else-if="posicao">
                            <icon-color font-size="50px" :color-ign-off="posicao.color_icon" :ign="posicao.ignition" icon="car"></icon-color>
                        </td>

                        <td>
                            <h6>
                                <span v-if="veiculo">
                                    <span style="font-size: 18px; font-weight: bold">
                                        <vk-icon ratio="0.8" icon="user"></vk-icon>  {{ veiculo.cliente ? veiculo.cliente.nome : 'Sem Cliente' }}  &nbsp;&nbsp;&nbsp;
                                        |  &nbsp;&nbsp;&nbsp;
                                        <vk-icon ratio="0.8" icon="location"></vk-icon> Placa: <b class="text-uppercase">{{ veiculo.placa}}</b>
                                          &nbsp;&nbsp;&nbsp;
                                        <vk-icon v-if="posicao && posicao.ancorado" ratio="0.8" icon="bolt"></vk-icon>
                                        <a target="_blank" v-if="posicao && posicao.ancorado && veiculo.ancora" :href="'https://www.google.com.br/maps/place/'+ veiculo.ancora.latitude +','+ veiculo.ancora.longitude +'/@'+ veiculo.ancora.latitude +','+ veiculo.ancora.longitude +',18z'">
                                            Ver Ancora
                                        </a>
                                    </span>
                                    <span style="font-size: 16px; font-weight: bold" class="text-danger" v-if="veiculo.oficina">
                                        &nbsp;&nbsp; EM OFICINA
                                    </span>
                                    <span style="font-size: 16px; font-weight: bold" class="text-danger" v-if="veiculo.sinistro">
                                        &nbsp;&nbsp; EM MANUTENÇÃO
                                    </span>
                                    <br style="padding-top: 5px"/>

                                    <vk-icon ratio="0.8" icon="settings"></vk-icon>

                                    Marca: <span style="font-size: 13px; font-weight: bold" class="text-uppercase">{{ veiculo.marca }}</span> &nbsp;&nbsp;&nbsp;
                                    Modelo:<span style="font-size: 13px; font-weight: bold" class="text-uppercase"> {{ veiculo.modelo }}</span> &nbsp;&nbsp;&nbsp;
                                    Ano:<span style="font-size: 13px; font-weight: bold" class="text-uppercase"> {{ veiculo.ano }}</span> &nbsp;&nbsp;&nbsp;
                                    Chassi:<span style="font-size: 13px; font-weight: bold" class="text-uppercase"> {{ veiculo.chassi }}</span> &nbsp;&nbsp;&nbsp;
                                    Renavam:<span style="font-size: 13px; font-weight: bold" class="text-uppercase"> {{ veiculo.renavan }}</span> &nbsp;&nbsp;&nbsp;
                                    Cor:<span style="font-size: 13px; font-weight: bold" class="text-uppercase"> {{ veiculo.cor }}</span>

                                </span>

                                <span v-else><br/></span>
                                <br >

                                <div style="padding-top: 2px" v-if="rastreador">
                                    <vk-icon ratio="0.8" icon="tag"></vk-icon>
                                    <span style="font-size: 13px; font-weight: bold" class="text-uppercase">
                                        {{rastreador.cod_fab_rastreadores}} / {{rastreador.modelo.nome}}
                                    </span> &nbsp;&nbsp;&nbsp;

                                    <vk-icon ratio="0.8" icon="tag"></vk-icon>
                                    SERIAL: <span style="font-size: 13px; font-weight: bold" class="text-uppercase">{{ rastreador.serial }}</span> &nbsp;&nbsp;&nbsp;
                                    <vk-icon ratio="0.8" icon="clock"></vk-icon>
                                    Último dado transmitido:
                                    <span style="font-size: 13px; font-weight: bold">{{ rastreador.ultima_data_evento | date("DD-MM-YYYY HH:mm:ss") }}</span>  &nbsp;&nbsp;&nbsp;

                                    <vk-icon ratio="0.8" icon="rss"></vk-icon>
                                    PORTA: <span style="font-size: 14px; font-weight: bold">{{rastreador.porta}}</span>
                                </div>

                                <div style="padding-top: 2px" v-if="chip">
                                    <vk-icon ratio="0.8" icon="tag"></vk-icon>
                                    ICCID: <span style="font-size: 13px; font-weight: bold" class="text-uppercase">{{ chip.imei }}</span> &nbsp;&nbsp;&nbsp;
                                    <vk-icon ratio="0.8" icon="receiver"></vk-icon>
                                    Número:
                                    <span style="font-size: 13px; font-weight: bold">{{ chip.numero }}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Operadora:
                                    <span style="font-size: 13px; font-weight: bold">{{ String(chip.operadora).toUpperCase() }}</span>
                                </div>

                                <div style="padding-top: 2px" v-if="veiculo && posicao && posicao.ancorado">

                                </div>

                            </h6>
                            <div class="alert alert-danger" v-if="veiculo && veiculo.roubado">VEÍCULO ROUBADO</div>
                        </td>

                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import IconColor from "../layout/IconColor";
    import {date} from '../../filter';
    import GoogleEarthButton from '../buttons/GoogleEarthButton.vue';
    import GoogleStreetViewButton from '../buttons/GoogleStreetViewButton.vue';
    import GoogleMapsButton from '../buttons/GoogleMapsButton.vue';
    import IconSateliteTransmissao from '../icons/IconSateliteTransmissao.vue';
    import {Chip} from '../../class';
    export default {
        name: 'HeaderAdmin',
        components: {IconSateliteTransmissao, GoogleMapsButton, GoogleStreetViewButton, GoogleEarthButton, IconColor},
        props: {
            veiculo: {
                default: null
            },
            posicao: {
                default: null
            },
            rastreador: {
                default: null
            },
            /** Layout em blocos (grade + tipografia), sem margens negativas — ideal para painéis e formulários */
            embedded: {
                type: Boolean,
                default: false
            },
            /** Resumo mínimo (cliente + placa + veículo); quando true, não usa o layout embedded completo nem a tabela clássica. */
            embeddedMinimal: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                chip: null
            }
        },
        filters: {
            date
        },
        beforeMount() {
            this.getChip();
        },
        methods: {
            getChip () {
                if (this.rastreador && this.rastreador.id_chip) {
                    Chip.byPK(this.rastreador.id_chip)
                        .then(data => {
                            this.chip = data
                        })
                        .catch((err) => console.error(err));
                }
            }
        }
    };
</script>

<style scoped>
    .header-admin-minimal {
        font-size: 14px;
        line-height: 1.4;
        color: #444;
    }

    .header-admin-minimal__client {
        font-size: 17px;
        font-weight: 600;
        color: #222;
        margin-bottom: 4px;
        word-break: break-word;
    }

    .header-admin-minimal__row {
        font-size: 13px;
        font-weight: 500;
        color: #555;
        letter-spacing: 0.02em;
    }

    .header-admin-minimal__placa {
        display: inline-block;
        font-weight: 700;
        letter-spacing: 0.06em;
        color: #fff;
        background: #337ab7;
        padding: 2px 8px;
        border-radius: 3px;
        font-size: 13px;
    }

    .header-admin-minimal__dot {
        margin: 0 8px;
        color: #ccc;
        font-weight: normal;
    }

    .header-admin-minimal__veic {
        font-weight: 600;
        color: #666;
    }

    .header-admin-minimal__flags {
        margin-top: 10px;
    }

    .header-admin-minimal__flags .label + .label {
        margin-left: 6px;
    }

    .header-admin-minimal__flags .label {
        font-size: 11px;
        font-weight: 600;
        padding: 3px 8px;
    }

    .header-admin-minimal__alert {
        margin-top: 12px;
        margin-bottom: 0;
        padding: 8px 12px;
    }

    .header-admin-embedded {
        font-size: 14px;
        line-height: 1.45;
    }

    .header-admin-embedded__main {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 18px 20px;
    }

    .header-admin-embedded__icons {
        display: flex;
        flex-shrink: 0;
        gap: 12px;
        padding-top: 4px;
    }

    .header-admin-embedded__icon-wrap {
        flex-shrink: 0;
    }

    .header-admin-embedded__body {
        flex: 1;
        min-width: 220px;
    }

    .header-admin-embedded__head {
        margin-bottom: 16px;
    }

    .header-admin-embedded__client {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 6px;
        word-break: break-word;
    }

    .header-admin-embedded__sub {
        font-size: 14px;
        color: #555;
        margin-bottom: 10px;
    }

    .header-admin-embedded__placa {
        display: inline-block;
        margin-left: 6px;
        padding: 2px 10px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        font-size: 15px;
        color: #fff;
        background-color: #337ab7;
        border-radius: 3px;
    }

    .header-admin-embedded__sep {
        margin: 0 10px;
        color: #bbb;
        font-weight: normal;
    }

    .header-admin-embedded__mini {
        font-size: 13px;
        font-weight: 600;
        color: #777;
    }

    .header-admin-embedded__tags .label + .label {
        margin-left: 6px;
    }

    .header-admin-embedded__ancora-link {
        margin-left: 6px;
        color: #fff;
        text-decoration: underline;
    }

    .header-admin-embedded__grid {
        margin-left: -8px;
        margin-right: -8px;
    }

    .header-admin-embedded__grid > [class*="col-"] {
        padding-left: 8px;
        padding-right: 8px;
    }

    .header-admin-field {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        background: #fafafa;
        padding: 10px 12px;
        margin-bottom: 12px;
        min-height: 58px;
    }

    .header-admin-field__label {
        display: block;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #888;
        margin-bottom: 4px;
    }

    .header-admin-field__value {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        word-break: break-word;
    }

    .header-admin-embedded__block {
        margin-top: 18px;
        padding-top: 16px;
        border-top: 1px solid #eee;
    }

    .header-admin-embedded__block-title {
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #888;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .header-admin-embedded__block-line {
        margin-bottom: 6px;
        color: #444;
        word-break: break-word;
    }

    .header-admin-embedded__block-line:last-child {
        margin-bottom: 0;
    }

    .header-admin-embedded__inline-sep {
        display: inline-block;
        width: 1px;
        height: 12px;
        margin: 0 12px;
        background: #ddd;
        vertical-align: middle;
    }

    .header-admin-embedded__alert {
        margin-top: 16px;
        margin-bottom: 0;
    }
</style>
